import App from '@/App';
import Portail from '@/views/Portail';
import Portails from '@/views/Portails';
import NotFound from '@/views/NotFound';
import { PAGE_NOT_FOUND, PAGE_PORTAIL_CLIENT, PAGE_RECOM } from '@/router/routerConf';

export default [
  {
    path: '/',
    name: 'home',
    component: App,
    children: [
      {
        path: 'recom',
        name: PAGE_RECOM,
        component: Portail,
      },
      {
        path: 'portail',
        name: PAGE_PORTAIL_CLIENT,
        component: Portails,
      },
    ]
  },
  {
    path: '*',
    name: PAGE_NOT_FOUND,
    component: NotFound,
  },
]
